import { ModelCategory, Station } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties';
import { ScheduleLineGroupSchema } from './ScheduleLineGroupSchema';

export const ScheduleStationSchema = new ModelSchema<Station>('scheduleStation', {
  category: ModelCategory.IntermediateModel,

  children: {
    scheduleLineGroup: ScheduleLineGroupSchema,
  },

  properties: {
    guid: StringProperty.configure({ readOnly: true }),
  },
});
